import {getHistory} from 'api/ReportHistoryApi';
import resizedDasWebUri, {presetDimensions} from 'components/imaging/ResizedDasWebImage';
import ReportHistoryListWithShareContainer from 'components/ReportHistoryListWithShare';
import 'components/ReportHistorySection.scss';
import Spinner from 'components/Spinner';
import {Component} from 'react';
import {Button, Container} from 'semantic-ui-react';
import connected from '../connected';

export class ReportHistorySection extends Component {

  state = {
    history: [],
    loading: true,
    error: false,
  };

  componentDidMount() {
    this.loadHistory();
  }

  loadHistory = async () => {
    try {
      this.setState({error: false});
      const {data} = await getHistory();
      this.setState({
        loading: false,
        error: false,
        history: this.processHistory(data),
      });
    } catch (e) {
      this.setState({error: true});
    }
  };

  processHistory = (data) => {
    const history = data.history || [];
    return history.map(item => {
      item.photoUri = resizedDasWebUri({
        uri: item.photoUri,
        resizeDimensions: presetDimensions.THUMBNAIL
      });
      return item;
    });
  };

  render() {
    const {history, loading, error} = this.state;
    return (
      <Container className="reports-history">
        {error ? (
          <div className="ui error">
            <p>An error occurred while loading the report history.</p>
            <Button onClick={this.loadHistory}>Retry</Button>
          </div>
        ) : (
          loading ? (
            <Spinner/>
          ) : (
            <ReportHistoryListWithShareContainer history={history}/>
          )
        )}
      </Container>
    );
  }
}

export default connected(ReportHistorySection);
